import { Building } from './Building';
export class TallGrass extends Building {
  readonly type = 'tallGrass' as const;
}
